module.exports = "<p>\n  about works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/dev-man/Kgwetlwo-app/src/app/pages/about/about/about.component.html
// module id = ../../../../../src/app/pages/about/about/about.component.html
// module chunks = main